exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-icon-app-6mQyU6NVmwr{box-shadow:0px 1px 2px 0px rgba(0,0,0,0.2);border-radius:25%}.app-icon-os-icon-4f8phWTomwr{display:inline-flex}.app-icon-ios-2HagqVGRmwr{border-radius:20%;-webkit-mask-image:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY1IDBjMTAuMiAwIDE1LjIgMCAyMC42IDEuN0M5MS42IDQgOTYgOC41IDk4LjMgMTQuNCAxMDAgMTkuOCAxMDAgMjQuOCAxMDAgMzV2MzBjMCAxMC4yIDAgMTUuMi0xLjcgMjAuNi0yLjIgNi02LjggMTAuNS0xMi43IDEyLjdDODAuMiAxMDAgNzUuMiAxMDAgNjUgMTAwSDM1Yy0xMC4yIDAtMTUuMiAwLTIwLjYtMS43QzguNCA5NiA0IDkxLjUgMS43IDg1LjYgMCA4MC4yIDAgNzUuMiAwIDY1VjM1YzAtMTAuMiAwLTE1LjIgMS43LTIwLjZDNCA4LjQgOC41IDQgMTQuNCAxLjcgMTkuOCAwIDI0LjggMCAzNSAwaDMweiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+\");mask-image:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY1IDBjMTAuMiAwIDE1LjIgMCAyMC42IDEuN0M5MS42IDQgOTYgOC41IDk4LjMgMTQuNCAxMDAgMTkuOCAxMDAgMjQuOCAxMDAgMzV2MzBjMCAxMC4yIDAgMTUuMi0xLjcgMjAuNi0yLjIgNi02LjggMTAuNS0xMi43IDEyLjdDODAuMiAxMDAgNzUuMiAxMDAgNjUgMTAwSDM1Yy0xMC4yIDAtMTUuMiAwLTIwLjYtMS43QzguNCA5NiA0IDkxLjUgMS43IDg1LjYgMCA4MC4yIDAgNzUuMiAwIDY1VjM1YzAtMTAuMiAwLTE1LjIgMS43LTIwLjZDNCA4LjQgOC41IDQgMTQuNCAxLjcgMTkuOCAwIDI0LjggMCAzNSAwaDMweiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+\");-webkit-mask-size:100%;mask-size:100%}.app-icon-macos-4I6TcesImwr{border-radius:10%}.app-icon-android-6t3TDmILmwr{border-radius:10%}.app-icon-windows-6nK6vB8vmwr{background:#0075DA;border-radius:10%}.app-icon-generic-2RVDqEpPmwr{background:#fff;border-radius:10%}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"app": "app-icon-app-6mQyU6NVmwr",
	"os-icon": "app-icon-os-icon-4f8phWTomwr",
	"osIcon": "app-icon-os-icon-4f8phWTomwr",
	"ios": "app-icon-ios-2HagqVGRmwr app-icon-os-icon-4f8phWTomwr",
	"macos": "app-icon-macos-4I6TcesImwr app-icon-os-icon-4f8phWTomwr",
	"android": "app-icon-android-6t3TDmILmwr app-icon-os-icon-4f8phWTomwr",
	"windows": "app-icon-windows-6nK6vB8vmwr app-icon-os-icon-4f8phWTomwr",
	"generic": "app-icon-generic-2RVDqEpPmwr app-icon-os-icon-4f8phWTomwr"
};